import { CountryCode } from '@domains/country';
import { FieldRequirementsMap } from '@domains/documents-review/interfaces/interfaces';

/**
 * Fallback de campos obligatorios — refleja la configuración MANUAL vigente en los forms.
 *
 * Se usa solo cuando el servicio `field_requirements` no responde: garantiza que ante una
 * caída del servicio el comportamiento sea EXACTAMENTE el de hoy (nada cambia). Cuando el
 * servicio responde, él es la fuente de verdad y estos valores no se usan.
 *
 * Nota: `yearsOld` se omite a propósito. Es un campo calculado/disabled (derivado de
 * `constructionDate`, que sí es obligatorio) y su valor no se registra como input; marcarlo
 * `required` bloquearía el formulario. Su obligatoriedad se satisface vía `constructionDate`.
 */
export const DEFAULT_FIELD_REQUIREMENTS: Partial<
  Record<CountryCode, FieldRequirementsMap>
> = {
  [CountryCode.CO]: {
    hasAdmin: true,
    adminPrice: true, // condicional: solo se renderiza si hasAdmin
    constructionDate: true,
    propertyType: true,
    areaType: false,
    area: true,
    baths: true,
    floor: true,
    hasGarage: true,
    garage: true, // condicional: solo se renderiza si hasGarage
    hasTerrace: false,
    freeArea: false, // condicional: solo se renderiza si hasTerrace
    elevators: false,
    liens: true,
    liensCategory: true,
    lenderBank: false,
  },
  [CountryCode.MX]: {
    complex: true,
    propertyType: true,
    adminPrice: true, // condicional: solo se renderiza si propertyType === 3 (condominio)
    medianZone: true,
    zipCode: true,
    documentType: true,
    committeePriceArea: true,
    committeeLandArea: true,
    committeeExpansionArea: false,
    floor: true,
    rooms: true,
    baths: true,
    halfBaths: false,
    elevator: true,
    yearsOld: true,
    hasGarageDoc: true,
    garage: true, // condicional: solo se renderiza si hasGarageDoc
    parkingWithDoubleKeyOrDeed: true, // condicional: solo se renderiza si hasGarageDoc
    accessoryAreas: false,
  },
};
